// extracted by mini-css-extract-plugin
module.exports = {"labelList":"CardLabels_labelList__UBmUJ","genericLabel":"CardLabels_genericLabel__MddZ0","highlightLabel":"CardLabels_highlightLabel__7IS_7"};